export const ADD_INVESTMENTS_TO_CONTINUE = 'Please add investments to a company to continue';
export const COMP_GROUPS_SLUG = 'comp-groups';
export const COMPLETE_FUNDS_AND_COMPANY = 'Please complete funds and companies with cap tables';
export const CONTACT_INFORMATION = 'Contact Information';
export const CREATE_COMPANY_FIRST = 'Please create a company first';
export const EMPTY_COMPANIES = 'There are no companies associated with this Firm';
export const COMPANIES_ARE_NOT_AVAILABLE = 'There aren\'t any companies available for you to see';
export const CONTACT_SCALAR_FOR_VALUATIONS = 'Contact Scalar staff to get access to companies with valuations';
export const EMPTY_FIRM = 'There is no information associated with this Firm';
export const EMPTY_INVESTMENTS = 'There are no investments associated with the funds of this firm';
export const FIRM_SETTINGS = 'Firm Settings';
export const FIRM_SETTINGS_SLUG = 'settings';
export const FEATURE_SETTINGS_TAB = 'feature-settings';
export const FEATURE_SETTINGS_PAGE_TITLE = 'Feature Settings';
export const FIRM_WATERFALLS_SLUG = 'waterfalls';
export const FIRMS_FIRM_SUMMARY_PAGE = 'Firm Summary';
export const FIRMS_FUND_SUMMARIES = 'Fund Summaries';
export const FIRMS_SUMMARY_SLUG = 'summary';
export const INTELLIGENCE_SLUG = 'intelligence';
export const INTELLIGENCE_SUMMARIES_SLUG = 'summaries';
export const INTELLIGENCE_SCHEDULE_OF_INVESTMENTS_SLUG = 'schedule-of-investments';
export const INTELLIGENCE_DAILY_NAV_SLUG = 'daily-nav';
export const INTELLIGENCE_FIRM_SUMMARY_SLUG = 'firm-summary';
export const SINGLE_SIGN_ON_TAB = 'sso';
export const SINGLE_SIGN_ON_PAGE_TITLE = 'Single Sign-On';
export const SCIM_CONFIGURATION_TAB = 'scim';
export const SCIM_CONFIGURATION_PAGE_TITLE = 'SCIM';
export const SCIM_STANDALONE_USER_PROVISIONING_TOOLTIP =
  'Provisioning users without groups is only partially supported. These users are assigned the ANALYST role by default. You can change roles manually in the User Management tab.';
export const DAILY_NAV_SETTINGS_TAB = 'daily-nav-settings';
export const DAILY_NAV_SETTINGS_PAGE_TITLE = 'Daily NAV Settings';
export const DAILY_NAV_COMPANIES_TAB = 'daily-nav-companies';
export const DAILY_NAV_COMPANIES_PAGE_TITLE = 'Daily NAV Companies';
export const DAILY_NAV_SETUP_TAB = 'daily-nav-setup';
export const DAILY_NAV_SETUP_PAGE_TITLE = 'Daily NAV Setup';
// The one firm-settings tab that groups Daily NAV's settings, companies, and setup pages.
export const DAILY_NAV_NAVIGATION_LABEL = 'Daily NAV';
export const SCALAR_AI_SETTINGS_TAB = 'scalar-ai';
export const SCALAR_AI_SETTINGS_PAGE_TITLE = 'Scalar AI';
export const MAXIMUM_ALLOWED_EFFORT_LABEL = 'Maximum Allowed Effort';
export const DEFAULT_SELECTED_EFFORT_LABEL = 'Default Selected Effort';
// Neutral stand-in shown when the firm's stored effort sits above the tiers this
// user may see. It must never name a tier - that is the whole point of it.
export const EFFORT_MANAGED_BY_SCALAR_LABEL = 'Managed by Scalar';
export const FORBIDDEN_FIRM_SUMMARY = 'You do not have permissions to view the firm summary';
export const GET_FIRM_SUMMARY_ACCESS = 'Please contact your manager to gain access';
export const REQUESTS = 'Requests';
export const REQUIRES_2FA = 'Require 2FA for all Users';
export const SHOW_PROCESS_MANAGEMENT_COLUMN = 'Show Process Management Columns';
export const ENABLE_FUND_INVESTMENTS = 'Enable Direct and Fund Investments';
export const ENABLE_DOCUMENT_AUTO_CLASSIFICATION = 'Enable Document Auto-Classification';
export const ENABLE_MCP = 'Enable MCP (Claude Desktop Integration)';
export const ENABLE_DAILY_NAV = 'Enable Daily NAV';
export const USE_SELECTED_NUMBER_FORMAT_FOR_INPUTS = 'Enter values using number format selected';
export const REQUIRES_2FA_TOOLTIP =
  '2-Factor Authentication is now required for all users in Scalar’s Platform.';
export const SHOW_PROCESS_MANAGEMENT_COLUMN_TOOLTIP =
  'Process Management columns appear on Valuations firm pages and allow tracking completion of document requests and questionnaires with portfolio companies.';
export const ENABLE_FUND_INVESTMENTS_TOOLTIP =
  'Allows this firm to track investments made directly in portfolio companies and investments made through other funds.';
export const ENABLE_DAILY_NAV_TOOLTIP =
  'The Daily NAV feature allows portfolio monitoring features that allow setting a daily price for all portfolio companies using secondary transactions and public comps with specified alerting thresholds.';
export const USE_SELECTED_NUMBER_FORMAT_FOR_INPUTS_TOOLTIP =
  'This setting currently applies only to editable monetary inputs in Waterfall. When enabled, all users in this firm enter those values using the selected display units, such as ($) Millions or ($) Thousands. For example, enter 1.5 to represent $1.5 million. When disabled (default), Waterfall inputs are entered as actual values.';
export const FIRMS_MEASUREMENT_DATE = 'Measurement Date';
export const SELECT_ALL_COMPANIES = 'Select all companies';
export const UNSELECT_ALL_COMPANIES = 'Unselect all companies';
export const USE_COMPANY_TEMPLATE_TOOLTIP =
  'When selected, creating requests will use company templates rather than the firm template. Company templates can be updated from each company\'s document page, and synced to the firm request template from the firm request page.';

export const FIRM_FUND_STEPPER_BASE_STATE = Object.freeze({
  values: {},
  isValid: false,
  dbErrors: {},
  errors: {},
});

export const FIRM_FUND_STEPPER_TITLES = Object.freeze({
  0: 'Create New Firm',
  1: 'Create New Fund',
});

export const FIRM_FIELDS_CONSTRAINTS = Object.freeze({
  name: {
    length: { minimum: 3, maximum: 100, message: 'must be at least 3 and less than 100 characters' },
    presence: { allowEmpty: false, message: 'is required' },
  },
  website: {
    url: true,
  },
  zip_code: {
    length: { minimum: 3, maximum: 12, message: 'must be at least 3 and less than 12 characters' },
    format: {
      message: 'must be a valid zip code, containing only numbers',
      pattern: '^\\d{3,12}$',
    },
  },
  phone_number: {
    format: {
      message: 'must be at least 10 and at most 15 characters, with no spaces, hyphens, or brackets',
      pattern: '^(\\+)?1?\\d{10,15}$',
    },
  },
  country: {
    presence: { allowEmpty: false, message: 'is required' },
  },
  state: {
    length: { minimum: 0, message: 'must be at most 30 characters', maximum: 30 },
  },
  street_address: {
    length: { minimum: 0, message: 'must be at most 100 characters', maximum: 100 },
  },
});

// Requests page

export const REQUEST_TITLE = (name: string) => `Request Defaults for ${name}`;
export const boldTextFooter = 'Ready to onboard the companies?';
export const DOCUMENT_REQUEST_DESCRIPTION =
  'The recipient will need to upload a document that includes the information for each request.';
export const DOCUMENT_REQUEST_TITLE = 'Document Requests';
export const PROCESS_MANAGEMENT = 'Process Management';
export const QUESTION_REQUEST_DESCRIPTION =
  'Use the questions to request additional information that will be needed to complete the valuation.';
export const QUESTION_REQUEST_TITLE = 'Questions';
export const REQUEST_DESCRIPTION =
  'This page specifies the default document requests and default questions that will be sent to companies when the initial request process has been started for each company. Requests can be configured to be assigned only to a specific company, using the edit options.';
export const CREATE_REQUESTS = 'Create Requests';
export const CREATE_REQUESTS_TOOLTIP =
  'Create document requests for firm management only. These tasks can be viewed from the Documents page of each company. No email will be sent.';
export const SEND_REQUESTS = 'Send Requests';
export const CREATE_OR_SEND_REQUESTS = 'Create or Send Requests';
export const SEND_REQUESTS_TOOLTIP = 'Send request to individual company users via email.';
export const SYNC_COMPANY_TEMPLATES = 'Sync Company Templates';
export const TEXT_FOOTER =
  'Ready to onboard the companies? Confirm or modify the documents and question that need to be requested from each company. When ready, press Send Requests to confirm the companies you would like to receive these current requests.';
// document and question requests modal
export const PICK_ANSWER_TYPE = 'Pick answer type';
export const TEXT_TYPE_LABEL = 'text';
export const DATE_TYPE_LABEL = 'date';
export const DROPDOWN_TYPE_LABEL = 'dropdown';
export const MULTIPLE_TYPE_LABEL = 'multiple';
export const QUESTION_TYPE_CHOICES = [
  { value: 0, label: TEXT_TYPE_LABEL },
  { value: 1, label: DATE_TYPE_LABEL },
  { value: 2, label: DROPDOWN_TYPE_LABEL },
  // { value: 3, label: MULTIPLE_TYPE_LABEL },
];
export const MAX_DROPDOWN_OPTIONS = 5;
export const questionModalMetadata = {
  name: 'Question',
  namePlaceholder: 'Question example?',
  description: 'Question description',
  descriptionPlaceholder: 'Add a brief description to the question requirements',
};
export const requestedDocumentModalMetadata = {
  name: 'Document Name',
  namePlaceholder: 'Enter name of requested document and press enter',
  description: 'Document description',
  descriptionPlaceholder: 'Add a brief description to the document',
};

// Tasks progress
export const ARE_YOU_SURE = 'Are you sure?';
export const MODAL_ACTION_BUTTON = 'Send Requests';
export const MODAL_TITLE = 'Select companies to send requests';
export const NO_COMPANIES_FOUND = 'No companies found';
export const NO_MEASUREMENT_DATE_SET = 'No measurement date set';
export const REQUEST_ALREADY_EXISTS = 'Companies with request already created';
export const NO_COMPANY_USERS = 'No company users';
export const NO_TASKS = 'No tasks required';
export const TASK_COMPLETION = 'Task Completion';
export const TIMEZONE = 'America/New_York';
export const QUESTIONS_TYPES = Object.freeze({
  text: 'text',
  dropdown: 'dropdown',
  date: 'date',
});

// Input Names:
export const PHONE_NUMBER = 'phone_number';
export const WEBSITE = 'website';
